import { Suspense, lazy } from "react";

import { Box, Typography } from "@mui/material";

import { Spinner } from "@climatepartner/components";
import { useAuth } from "@climatepartner/hooks";
import { parseFullName } from "@climatepartner/utils";

import { HomepageTiles } from "../components/HomepageTiles";
import { useServices } from "../helpers/useServices";
import { getNsTrans } from "../plugins/translations";

const Trans = getNsTrans("homepage");
const FORMS_SERVICE_NAME = "reduction-forms";

const Homepage = () => {
    const { user, hasPermission } = useAuth();
    const shouldShowForms = hasPermission(`${FORMS_SERVICE_NAME}.access`);
    const enabledServices = useServices();
    const fullUserName = parseFullName(user?.name || "");

    return (
        <Box>
            <Typography
                sx={{
                    marginBottom: 4,
                    fontWeight: 400,
                    fontSize: "35px",
                }}
            >
                <Trans>Welcome</Trans>{" "}
                <Box
                    component="span"
                    sx={{
                        textTransform: "capitalize",
                    }}
                >
                    {fullUserName?.firstName} {fullUserName?.lastName}
                </Box>
            </Typography>

            <HomepageTiles userServiceLinks={enabledServices} />

            {shouldShowForms ? RenderReductionForms() : null}
        </Box>
    );
};

const RenderReductionForms = () => {
    const ReductionFormsSection = lazy(() => import("../containers/DataProviderSection"));

    return (
        <Suspense fallback={<Spinner />}>
            <ReductionFormsSection />
        </Suspense>
    );
};

export default Homepage;
